import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Checkbox, FormControlLabel, Grid, Stack } from '@mui/material'
import { connect, useSelector } from 'react-redux'
import DropDownOA from '../../../../common/dropDownOA'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import MapIcon from '@mui/icons-material/Map';
import Datepicker from '../../../../common/datePicker'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import MapLocation from './MapLocation'
import AssignCitiesModal from './AssignCitiesModal'
import Lineinput from '../../../../common/lineinput'
import ConfirmationModal from './ConfirmationModal'
import { addDaysToDate, focusElemnt, getAddressbyPosition, getRecentSearches, isEmpty, isNull, navigation1, navigation3, removeDuplicatesFromArray, savePickupAddress, savedPickupList, subtractDaysFromDate } from '../../../../common/helper'
import { commissionList, ctreditLimitList, statusList } from '../constants'
import { getBranchAndCityList, validateGSTNumber, partyConfigInsertUpdate } from '../../../../../store/generalSetting/GSAction'
import { getCityList, verifyPanNumber } from '../../../../../store/branchAndUserMaster/BUMAction'
import moment from 'moment'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import PartySaveEditOtpModal from './PartySaveEditOtpModal'
import { luggageSendOTP } from '../../../../common/jotaiState/commonStateAtoms'

const CreateNewPartyModal = (props) => {
    const { data: { common }, validateGSTNumber, updateAlertError, verifyPanNumber, getCityList, getBranchAndCityList, partyConfigInsertUpdate, 
        dataValues: { isEdit, headerText, updateModal, getTableData }, editData, goToTabs } = props
    const { loginData, companySettings } = common
    const [showMobileModal, setShowMobileModal] = useState(false)
    const [showOtpModal, setShowOtpModal] = useState(false)
    const [verifyMobileNoData, setVerifyMobileData] = useState({})
    const [verifyOtpData, setVerifyOtpData] = useState({})
    const [showLocationModal, setShowLocationModal] = useState(false)
    const [locationData, setLocationData] = useState({})
    const [showAssignCityModal, setShowAssignCityModal] = useState(false)
    const [assignCityData, setAssignCityData] = useState({})
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [confirmData, setConfirmData] = useState({})
    const [accBranchList, setAccBranchList] = useState([])
    const [cityOptList, setCityOptList] = useState([])
    const [BranchAddress, setBranchAddress] = useState('')
    const [isSuccess, setIsSuccess] = useState(false)
    const [resetDelDD, setResetDelDD] = useState(false)
    const [resetBkgDD, setResetBkgDD] = useState(false)
    const [validated, setValidated] = useState({ gstValidated: false, panValidated: false, mobileNoValidated: false })
    const [filters, setFilters] = useState({})
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }

    useEffect(() => {
        focusElemnt('cnPartyName')
    }, [])
    useEffect(() => {
        setValidated({ gstValidated: false, panValidated: false, mobileNoValidated: false })

        if (isEdit) {
            setValidated((prev) => ({
                ...prev,
                gstValidated: editData?.IsGSTValid === "Yes" ? true : false
            }))
            setFilters((prev) => ({
                ...prev,
                ...editData,
                AccountingBranch: editData?.AccountingBranch,
                AccountingBranchID: editData?.AccountingBranchID,
                Address: editData?.Address,
                BookingCreditLimit: editData?.BookingCreditLimit,
                BookingCreditLimitDD: editData?.BookingCreditLimit === 0 ? ctreditLimitList?.[1] : ctreditLimitList?.[0],
                Commission: editData?.CommissionAmt === 0 ? commissionList?.[0] : commissionList?.[1],
                CommissionAmt: editData?.CommissionAmt,
                CommissionPCT: editData?.CommissionPCT,
                ContactPerson: editData?.ContactPerson,
                DeliveryCreditLimit: editData?.DeliveryCreditLimit,
                DeliveryCreditLimitDD: editData?.DeliveryCreditLimit === 0 ? ctreditLimitList?.[1] : ctreditLimitList?.[0],
                Discount: editData?.Discount,
                EmailID: editData?.EmailID,
                GSTN: editData?.GSTN,
                IsActive: editData?.IsActive,
                IsBookingCreditParty: editData?.IsBookingCreditLimit,
                IsCorporateParty: editData?.IsCorporateParty,
                IsCreditParty: editData?.IsCreditParty,
                IsDeleted: editData?.IsDeleted,
                IsDelCreditParty: editData?.IsDeliveryCreditLimit ? 1 : 0,
                IsRateIncludeAll: editData?.IsRateIncludeAll,
                IsRCM: editData?.IsRCM,
                IsReceivingParty: editData?.IsReceivingParty,
                MappedBranchID: editData?.MappedBranchID,
                MappedToBranch: editData?.MappedBranch,
                MobileNo: editData?.MobileNo,
                PAN: editData?.PAN,
                Party: editData?.Party,
                PartyCitiesNames: editData?.PartyCitiesNames?.replaceAll('~', ', '),
                PhoneNo: editData?.PhoneNo,
                Remarks: editData?.Remarks,
                ServiseTaxPayer: editData?.ServiseTaxPayer,
                TargetAmount: editData?.TargetAmount,
                TargetEndDate: moment(editData?.TargetEndDate).format('YYYY-MM-DD') === "Invalid date" ? moment(new Date()) : editData?.TargetEndDate,
                TargetStartDate: moment(editData?.TargetStartDate).format('YYYY-MM-DD') === "Invalid date" ? moment(new Date()) : editData?.TargetStartDate,
                TradeName: editData?.TradeName,
                dblCreditBalance: 0,
                dblCreditLimit: 0,
                dblDiscountPercentage: editData?.IsReceivingParty,
                gstinAddress: editData?.gstinAddress,
                gstinEntityName: editData?.gstinEntityName,
                gstinState: editData?.gstinState,
                isValid: editData?.IsGSTNValidated,
                CreatedBy: editData?.CreatedBy===''? loginData?.strUserName:editData?.CreatedBy,
                AuthorizedBy:editData?.AuthorizedBy  
            }))
        } else {
            setFilters({
                AccountingBranch: '',
                AccountingBranchID: 0,
                Address: '',
                BookingCreditLimit: 0,
                BookingCreditLimitDD: '',
                CSTNO: '',
                CityID: '',
                Commission: commissionList?.[0],
                CommissionAmt: 0,
                CommissionPCT: 0,
                CompanyID: locationData?.intCompanyID,
                ContactPerson: '',
                DeliveryCreditLimit: 0,
                DeliveryCreditLimitDD: '',
                Discount: 0,
                EmailID: '',
                GSTN: '',
                IsActive: 1,
                IsBookingCreditParty: 0,
                IsCorporateParty: 0,
                IsCreditParty: 0,
                IsDelCreditParty: 0,
                IsDeleted: 0,
                IsRCM: 0,
                IsRateIncludeAll: 0,
                IsReceivingParty: 0,
                MappedBranchID: 0,
                MappedToBranch: 0,
                MobileNo: '',
                PAN: '',
                Party: '',
                PartyCitiesNames: '',
                PartyID: 0,
                PhoneNo: '',
                Remarks: '',
                STNO: '',
                ServiseTaxPayer: 0,
                TargetAmount: 0,
                TargetEndDate: '',
                TargetStartDate: '',
                TradeName: '',
                dblCreditBalance: 0,
                dblCreditLimit: 0,
                dblDiscountPercentage: 0,
                gstinAddress: '',
                gstinEntityName: '',
                gstinState: '',
                isValid: 0,
                CreatedBy: loginData?.strUserName,
                AuthorizedBy:'' 
            })
        }
    }, [editData])

    useEffect(() => {
        if (!isEmpty(loginData)) {
            let body = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intBranchID: 0,
                strBranchName: "",
                strBranchCode: "",
                intStateID: 0,
                intCityID: 0,
                intIsActive: 1
            }
            getBranchAndCityList(body, true, 24 * 60 * 60 * 1000).then((res) => {
                if (res.status === 'Success') {
                    let newData = removeDuplicatesFromArray(res.Data.Table, 'BranchID')
                    setAccBranchList(newData)
                } else {
                    setAccBranchList([])
                    updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Source_State' })
                }

                let body1 = {
                }
                getCityList(body1,true, 24 * 60 * 60 * 1000).then((res) => {
                    if (res.status === 'Success') {
                        let newData = removeDuplicatesFromArray(res.Data.Table, 'CityID')
                        const cityNames = newData.map(city => ({ CityID: city.CityID, CityName: city.Cityname }));
                        setCityOptList(cityNames)
                    } else {
                        setCityOptList([])
                    }
                }).catch((err) => {
                    console.log('Error:', err)
                })
            })
        }
    }, [loginData])
    useEffect(() => {
        if (BranchAddress?.formatted_address) {
            setFilters((prev) => ({
                ...prev,
                Address: `${BranchAddress.hasOwnProperty('flatNo') ? BranchAddress?.flatNo !== '' ? BranchAddress?.flatNo + ',' : '' : ''}${BranchAddress.hasOwnProperty('building') ? BranchAddress?.building !== '' ? BranchAddress?.building + ',' : '' : ''}${BranchAddress.hasOwnProperty('howToReach') ? BranchAddress?.howToReach !== '' ? BranchAddress?.howToReach + ',' : '' : ''}${BranchAddress?.formatted_address || ''}`
            }))
        }
    }, [BranchAddress])
    const getcurrentLocation = () => {
        setBranchAddress('')
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getAddressbyPosition)
        } else {
            console.log('Geolocation is not supported by this browser.')
        }
    }
    const showloactionModal = () => {
        let data = {
            updateModal: setShowLocationModal,
            headText: "Map Location",
            savedAddressList: savedPickupList(),
            getcurrentLocation,
            saveAction: () => { savePickupAddress(BranchAddress) },
            isDeliver: false,
            originLatLong: [],
            originPlace: ''
        }
        setLocationData(data)
        setShowLocationModal(true)
    }

    const showUpdateMblNoVrifyModal = (otp) => {
        const dataValues = {
            updateModal: setShowMobileModal,
            headerText: ' Mobile No. Verification',
            otpInfo: otp,
            resendOTP: resendOTP,
            updateValidatedIcon: updateValidatedIcon
        }
        setVerifyMobileData(dataValues)
        setShowMobileModal(true)
    }
    const showUpdateOtpModal = (otp) => {
        const dataValues = {
            updateModal: setShowOtpModal,
            headerText: 'Submit OTP',
            otpInfo: otp,
            resendOTP: resendOTP,
            saveApi: saveApi
        }
        setVerifyOtpData(dataValues)
        setShowOtpModal(true)
    }
    const updateAssignCityModal = () => {
        let data = {
            updateModal: setShowAssignCityModal,
            headerText: "Assign Cities",
            filters: filters,
            setFilters: setFilters,
            cityOptList: cityOptList,
        }
        setAssignCityData(data)
        setShowAssignCityModal(true)
    }
    const updateConfirmationModal = () => {
        let data = {
            updateModal: setShowConfirmModal,
            headerText: "Corporate Rate Config.",
            filters: filters,
            saveRedirection: saveRedirection
        }
        setShowConfirmModal(true)
        setConfirmData(data)
    }
    const ValidatedIcon = () => {
        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'row', width: '94px', paddingTop: '5px', justifyContent: 'space-between' }}>
                    <span style={{ color: '#14C508', fontSize: '18px' }}>
                        <VerifiedUserIcon style={{ width: '22px', height: '26px' }} />
                    </span>
                    <span style={{ color: '#14C508', fontSize: '16px', paddingLeft: '5px', fontWeight: '500' }}>
                        Verified
                    </span>
                </div>
            </>
        )
    }
    const updateValidatedIcon = (param) => {
        setValidated((prev) => ({
            ...prev,
            mobileNoValidated: param
        }))
    }
    const validateGSTIN = () => {
        if (filters?.GSTN === '' || filters?.GSTN?.trim().length !== 15) {
            setFilters((prev) => ({
                ...prev,
                GSTN: '',
                PAN: ''
            }))
            updateAlertError({ show: true, msg: 'Enter Valid GST Number', nextId: 'cnGst' })
        } else {
            const obj = {
                GSTN: filters?.GSTN,
            }

            validateGSTNumber(obj)?.then((res) => {
                if (res.status === 'True' && isNull(res.error)) {
                    if (res?.Data?.length > 0 && !isEmpty(res?.Data[0])) {
                        let newData = res?.Data[0]
                        setValidated((prev) => ({
                            ...prev,
                            gstValidated: true
                        }))
                        setFilters((prev) => ({
                            ...prev,
                            gstinEntityName: newData?.CompanyName,
                            gstinState: newData?.State,
                            gstinAddress: newData?.DoorNo + ', ' + newData?.FloorNo + ', ' + newData?.BuildingName + ', ' + newData?.Street + ', ' + newData?.City + ', ' + newData?.State + ', ' + newData?.Pincode,
                            isValid: 1,
                            TradeName: newData?.Tradename,
                            PAN: filters?.GSTN?.substring(2, 12)
                        }))
                    }
                } else {
                    updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'cnGst' })
                    setValidated((prev) => ({
                        ...prev,
                        panValidated: false
                    }))
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }
    const handleOtpVarify = () => {
        const data = {
            StrEventType: 'Party Edit',
            intCompanyID: loginData.intCompanyID,
            intUserID: loginData.intUserID,
            strContactNo: (filters?.PhoneNo)?.toString(),
            intBookingID: 0,
            intMode: 4,
        }
        luggageSendOTP(data).then((res) => {
            if (res.Status == true) {
                showUpdateOtpModal(res?.OTP)
            } else if(res?.Status == false && res.ErrMessage === "Error:Policy & Number not updated"){
                saveApi()
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'cnPan' })
            }
        }).catch((err) => {
            console.log("Error:", err)
            updateAlertError({ show: true, msg: err, nextId: '' })
        })

    }
    const resendOTP = () => {
        const data = {
            StrEventType: 'Party Edit',
            intCompanyID: loginData.intCompanyID,
            intUserID: loginData.intUserID,
            strContactNo: (filters?.PhoneNo)?.toString(),
            intBookingID: 0,
            intMode: 4,
        }
        luggageSendOTP(data).then((res) => {
            if (res.Status == true) {
                showUpdateOtpModal(res?.OTP)
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'cnPan' })
            }
        }).catch((err) => {
            console.log("Error:", err)
            updateAlertError({ show: true, msg: err, nextId: '' })
        })
    }
    const validatePanNo = () => {
        const obj = {
            PanNumber: filters?.PAN
        }
        verifyPanNumber(obj).then((res) => {
            if (res?.status == 'True') {
                setValidated((prev) => ({
                    ...prev,
                    panValidated: true
                }))
            } else {
                updateAlertError({ show: true, msg: res.ErrMessage, nextId: 'cnPan' })
                setValidated((prev) => ({
                    ...prev,
                    panValidated: false
                }))
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const validateEmail = (e) => {
        let value = e.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value === '') {
            return
        } else if (!emailRegex.test(value)) {
            updateAlertError({ show: true, msg: 'Invalid Email Id', nextId: 'cnEmailId' })
        }
    }
    const handleSave = () => {
        if (filters?.Party === '') {
            updateAlertError({ show: true, msg: 'Please Enter Party Name', nextId: 'cnPartyName' })
        } else if (filters?.ContactPerson === '') {
            updateAlertError({ show: true, msg: 'Please Enter Contact Person', nextId: 'cnContactPerson' })
        } else if (filters?.Address === '') {
            updateAlertError({ show: true, msg: 'Please Enter Address', nextId: 'cnPartyAddress' })
        } 
        else if (companySettings?.IsPartyDetailsMandatory===1 && filters?.GSTN === '') {
            updateAlertError({ show: true, msg: 'Please Enter GSTIN', nextId: 'cnGst' })
        } 
        else if (companySettings?.IsPartyDetailsMandatory===1 && filters?.PAN === '') {
            updateAlertError({ show: true, msg: 'Please Enter PAN', nextId: 'cnPan' })
        } 
        else if (filters?.MobileNo === '') {
            updateAlertError({ show: true, msg: 'Please Enter Mobile Number', nextId: 'cnMobileNo' })
        } else if (filters?.MobileNo?.length < 10) {
            updateAlertError({ show: true, msg: `Please Enter a 10 Digit Mobile Number`, nextId: 'cnMobileNo' })
        } 
        else if (loginData?.intCompanyID===406 && filters?.TargetAmount === '') {
            updateAlertError({ show: true, msg: 'Please Enter Target Amount', nextId: 'cnTargetAmt' })
        } 
        else if (filters?.PartyCitiesNames === '') {
            updateAlertError({ show: true, msg: 'Please Select Assigned Cities', nextId: 'cnAssignedCity' })
        }
        else if (loginData?.intCompanyID===406 && (filters?.AuthorizedBy === '')) {
            updateAlertError({ show: true, msg: 'Please Enter Authorized By', nextId: 'cnTargetAmt' })
        } 
        // else if (!isEdit && !validated?.mobileNoValidated) {
        //     updateAlertError({ show: true, msg: 'Please Validate Mobile Number', nextId: 'cnMobileNo' })
        // }
        else if (filters?.CommissionPCT > 100) {
            updateAlertError({ show: true, msg: 'Comission Percentage Value Cannot Be Greater Than 100', nextId: 'cnPercentage' })
        }
        else {
            isEdit ? handleOtpVarify() : saveApi()
        }
    }
    const saveApi = () => {
        let body = {
          PartyID: isEdit ? filters?.PartyID : 0,
          CompanyID: isEdit ? filters?.CompanyID : loginData?.intCompanyID,
          Party: filters?.Party,
          ContactPerson: filters?.ContactPerson,
          CityIDs: filters?.CityID,
          Address: filters?.Address,
          Phone: filters?.PhoneNo,
          MobileNo: filters?.MobileNo,
          EmailID: filters?.EmailID,
          CSTNO: filters?.CSTNO,
          STNO: filters?.STNO,
          PAN: filters?.PAN,
          IsCreditParty: filters?.IsCreditParty,
          dblCreditLimit: filters?.CreditLimit,
          dblCreditBalance: filters?.CreditBalance,
          dblDiscountPercentage: filters?.DiscountPercentage,
          Remarks: filters?.Remarks,
          IsActive: filters?.IsActive,
          CommPct: filters?.CommissionPCT,
          CommAmt: filters?.CommissionAmt,
          ServiseTaxPayer: filters?.ServiceTaxPayer,
          IsDeleted: 0,
          MappedToBranch: filters?.MappedToBranch,
          GSTN: filters?.GSTN?.trim(),
          LoggedInUserID: loginData?.intUserID,
          dblBookingCreditLimit: filters?.BookingCreditLimit,
          IsBookingCreditParty: filters?.IsBookingCreditParty,
          IsDelCreditParty: filters?.IsDelCreditParty,
          AccountingBranchID: filters?.AccountingBranchID,
          IsRateIncludeAll: filters?.IsRateIncludeAll,
          IsReceivingParty: filters?.IsReceivingParty,
          IsCorporateParty: filters?.IsCorporateParty,
          IsRCM: filters?.IsRCM,
          gstinEntityName: filters?.gstinEntityName,
          gstinState: filters?.gstinState,
          gstinAddress: filters?.gstinAddress,
          TradeName: filters?.TradeName,
          Discount: filters?.Discount,
          TargetAmount: filters?.TargetAmount,
          TargetStartDate: filters?.TargetStartDate === '' ? '' : moment(filters?.TargetStartDate).format('YYYY-MM-DD'),
          TargetEndDate: filters?.TargetStartDate === '' ? '' : moment(filters?.TargetEndDate).format('YYYY-MM-DD'),
          ModifiedByUserID: loginData?.intUserID,
          isValid: filters?.isValid ? 1 : 0,
          CreatedBy: isEdit ? filters?.CreatedBy : loginData?.intUserID,
          AuthorizedBy: filters?.AuthorizedBy,
        }
        partyConfigInsertUpdate(body).then((res) => {
            if (res.status === 'Success') {
                setIsSuccess(true)

            } else {
                updateAlertError({ show: true, msg: res?.Message })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const saveRedirection = () => {
        let body = {
            PartyID: isEdit ? filters?.PartyID : 0,
            CompanyID: isEdit ? filters?.CompanyID : loginData?.intCompanyID,
            Party: filters?.Party,
            ContactPerson: filters?.ContactPerson,
            CityIDs: filters?.CityID,
            Address: filters?.Address,
            Phone: filters?.PhoneNo,
            MobileNo: filters?.MobileNo,
            EmailID: filters?.EmailID,
            CSTNO: filters?.CSTNO,
            STNO: filters?.STNO,
            PAN: filters?.PAN,
            IsCreditParty: filters?.IsCreditParty,
            dblCreditLimit: filters?.CreditLimit,
            dblCreditBalance: filters?.CreditBalance,
            dblDiscountPercentage: filters?.DiscountPercentage,
            Remarks: filters?.Remarks,
            IsActive: filters?.IsActive,
            CommPct: filters?.CommissionPCT,
            CommAmt: filters?.CommissionAmt,
            ServiseTaxPayer: filters?.ServiceTaxPayer,
            IsDeleted: filters?.IsDeleted,
            MappedToBranch: filters?.MappedToBranch,
            GSTN: filters?.GSTN?.trim(),
            LoggedInUserID: loginData?.intUserID,
            dblBookingCreditLimit: filters?.BookingCreditLimit,
            IsBookingCreditParty: filters?.IsBookingCreditParty,
            IsDelCreditParty: filters?.IsDelCreditParty,
            AccountingBranchID: filters?.AccountingBranchID,
            IsRateIncludeAll: filters?.IsRateIncludeAll,
            IsReceivingParty: filters?.IsReceivingParty,
            IsCorporateParty: filters?.IsCorporateParty,
            IsRCM: filters?.IsRCM,
            gstinEntityName: filters?.gstinEntityName,
            gstinState: filters?.gstinState,
            gstinAddress: filters?.gstinAddress,
            TradeName: filters?.TradeName,
            Discount: filters?.Discount,
            TargetAmount: filters?.TargetAmount,
            TargetStartDate: filters?.TargetStartDate === '' ? '' : moment(filters?.TargetStartDate).format('YYYY-MM-DD'),
            TargetEndDate: filters?.TargetStartDate === '' ? '' : moment(filters?.TargetEndDate).format('YYYY-MM-DD'),
            ModifiedByUserID: loginData?.intUserID,
            isValid: filters?.isValid ? 1 : 0
        }
        partyConfigInsertUpdate(body).then((res) => {
            if (res.status === 'Success') {
                goToTabs(2, filters)
            } else {
                updateAlertError({ show: true, msg: res?.Message })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const handleSuccessModalClose = () => {
        updateModal()
        setIsSuccess(false)
        getTableData()
    }
    const handleCancel = () => {
        setValidated({ gstValidated: false, panValidated: false, mobileNoValidated: false })
        updateModal()
    }

    return (
        <>

            <Modal
                headTxt={headerText}
                width={'89%'}
                updateModal={updateModal}
                closeId={"closeButton"}
                modalClass={'booking-popup'}
                modalStyle={modalStyle}
            >
                <>

                    <Stack style={{ display: 'flex', flexDirection: 'column', padding: '16px 16px 16px 16px' }}>
                        <Box style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.2)', paddingBottom: '12px', display: 'flex', flexDirection: 'row', gap: '12px', width: '100%' }}>
                            <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '22.55%' }}>
                                <Lineinput
                                    id='cnPartyName'
                                    label="Party Name"
                                    value={filters?.Party}
                                    onChange={(e) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            Party: e.target.value
                                        }))
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'cnContactPerson', '')
                                    }}
                                />
                            </Item>
                            <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '22.55%' }}>
                                <Lineinput
                                    id='cnContactPerson'
                                    label="Contact Person"
                                    value={filters?.ContactPerson}
                                    onChange={(e) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            ContactPerson: e.target.value
                                        }))
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'cnPartyAddress', 'cnPartyName')
                                    }}
                                />
                            </Item>
                            <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '38.75%' }}>
                                <Lineinput
                                    id='cnPartyAddress'
                                    label="Party Address"
                                    value={filters?.Address}
                                    onChange={(e) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            Address: e.target.value
                                        }))
                                    }}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'cnMapLoacation', 'cnContactPerson')
                                    }}
                                />
                            </Item>

                            <Item className="disabled-wrapper reportButton" sx={{ ...sx.itemsx, width: '14.25%' }}>
                                <Button id='cnMapLoacation' startIcon={<MapIcon style={{ color: '#0086FF' }} />} variant="outlined" sx={{ width: '100%' }} className="loactionBtn"
                                    onClick={() => showloactionModal()}
                                    onKeyDown={(e) => {
                                        navigation3(e, "cnGst", "cnPartyAddress", () => { showloactionModal() })
                                    }}
                                >
                                    Map Location
                                </Button>
                            </Item>
                        </Box>
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '12px' }}>
                            <Box style={{ display: 'flex', flexDirection: 'column', width: '22.55%', padding: '16px 0px 16px 0px', gap: '16px' }}>
                                <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnGst'
                                        label="GSTIN"
                                        value={filters?.GSTN}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                GSTN: e.target.value
                                            }))
                                            setValidated((prev) => ({
                                                ...prev,
                                                gstValidated: false
                                            }))
                                        }}
                                        onBlur={(e) => { }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnVAlidateGst', 'cnMapLoacation')
                                        }}
                                    />
                                </Item>
                                <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnPan'
                                        label="PAN"
                                        value={filters?.PAN}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                PAN: e.target.value
                                            }))
                                            setValidated((prev) => ({
                                                ...prev,
                                                panValidated: false
                                            }))
                                        }}
                                        onBlur={(e) => { }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnMobileNo', 'cnVAlidateGst')
                                        }}
                                    />
                                </Item>
                                <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnMobileNo'
                                        label="Mobile No."
                                        maxLength={10}
                                        // value={filters?.PhoneNo}
                                        // onChange={(e) => {
                                        //     setFilters((prev) => ({
                                        //         ...prev,
                                        //         PhoneNo: (e.target.value).replaceAll(/\D/g, '')
                                        //     }))
                                        //     setValidated((prev) => ({
                                        //         ...prev,
                                        //         mobileNoValidated: false
                                        //     }))
                                        // }}
                                        value={filters?.MobileNo}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                MobileNo: (e.target.value).replaceAll(/\D/g, '')
                                            }))
                                            setValidated((prev) => ({
                                                ...prev,
                                                mobileNoValidated: false
                                            }))
                                        }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnAltMobileNo', 'cnValidatePan')
                                        }}
                                    />
                                </Item>
                                {/* <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnAltMobileNo'
                                        label="Alternate Mobile No."
                                        maxLength={10}
                                        value={filters?.MobileNo}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                MobileNo: (e.target.value).replaceAll(/\D/g, '')
                                            }))
                                        }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnEmailId', 'cnValidateMobile')
                                        }}
                                    />
                                </Item> */}
                                 <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnAuthorizedBy'
                                        label="Authorized By"
                                        maxLength={50}
                                        value={filters?.AuthorizedBy}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                AuthorizedBy: e.target.value
                                            }))
                                        }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnIsBookingCreditParty', 'cnValidateMobile')
                                        }}
                                    />
                                </Item>
                            </Box>
                            <Box style={{ display: 'flex', flexDirection: 'column', width: '22.55%', padding: '16px 0px 16px 0px', gap: '16px' }}>
                                <Box style={{ display: 'flex', flexDirection: 'row', gap: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {validated?.gstValidated && <ValidatedIcon />}
                                    <Item sx={sx.itemsx} className="disabled-wrapper">
                                        <Button id='cnVAlidateGst' variant="contained" style={{ ...sx.fullHeight, ...sx.novp, padding: '15px 38px' }} className="btn btn-primary"
                                            onClick={() => {
                                                validateGSTIN()
                                            }}
                                            onKeyDown={(e) => {
                                                navigation3(e, "cnPan", 'cnMobileNo', () => { })
                                            }}
                                        >
                                            validate
                                        </Button>
                                    </Item>
                                </Box>
                                {/* <Box style={{ display: 'flex', flexDirection: 'row', gap: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {validated?.panValidated && <ValidatedIcon />} */}
                                    {/* <Item sx={sx.itemsx} className="disabled-wrapper"> */}
                                        {/* <Button id='cnValidatePan' variant="contained" style={{ ...sx.fullHeight, ...sx.novp, padding: '15px 38px' }} className="btn btn-primary" disabled
                                            onClick={() => {
                                                // validatePanNo()
                                            }}
                                            onKeyDown={(e) => {
                                                navigation3(e, "cnMobileNo", 'cnPan', () => { })
                                            }}
                                        >
                                            validate
                                        </Button> */}
                                    {/* </Item> */}
                                    <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnAltMobileNo'
                                        label="Alternate Mobile No."
                                        maxLength={10}
                                        // value={filters?.MobileNo}
                                        // onChange={(e) => {
                                        //     setFilters((prev) => ({
                                        //         ...prev,
                                        //         MobileNo: (e.target.value).replaceAll(/\D/g, '')
                                        //     }))
                                        // }}
                                        value={filters?.PhoneNo}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                PhoneNo: (e.target.value).replaceAll(/\D/g, '')
                                            }))
                                        }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnEmailId', 'cnValidateMobile')
                                        }}
                                    />
                                </Item>
                                {/* </Box> */}
                                {/* <Box style={{ display: 'flex', flexDirection: 'row', gap: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {validated?.mobileNoValidated && <ValidatedIcon />}
                                    <Item sx={{ ...sx.itemsx }} className="disabled-wrapper"> */}
                                        {/* <Button id='cnValidateMobile' variant="contained" style={{ ...sx.fullHeight, ...sx.novp, padding: '15px 38px' }} className="btn btn-primary" disabled
                                            onClick={() => {
                                                // handleMobileNoVarify()
                                                // showUpdateMblNoVrifyModal()
                                            }}
                                            onKeyDown={(e) => {
                                                navigation3(e, "cnAltMobileNo", 'cnMo', () => { showUpdateMblNoVrifyModal() })
                                            }}
                                        >
                                            validate
                                        </Button> */}
                                    {/* </Item>
                                </Box> */}
                                <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnEmailId'
                                        label="Email ID"
                                        value={filters?.EmailID}
                                        onChange={(e) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                EmailID: e.target.value
                                            }))
                                        }}
                                        onBlur={(e) => { validateEmail(e) }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnAssignedCity', 'cnAltMobileNo')
                                        }}
                                    />
                                </Item>
                                <Item className="input--wrapper" sx={{ ...sx.itemsxGrow }}>
                                    <Lineinput
                                        id='cnCreatedBy'
                                        label="Created By"
                                        disabled={true}
                                        value={filters?.CreatedBy}
                                        // onChange={(e) => {
                                        //     setFilters((prev) => ({
                                                // ...prev,
                                                // EmailID: e.target.value
                                        //     }))
                                        // }}
                                        onBlur={(e) => { validateEmail(e) }}
                                        onKeyDown={(e) => {
                                            navigation1(e, 'cnIsBookingCreditParty', 'cnAltMobileNo')
                                        }}
                                    />
                                </Item>
                            </Box>
                            <Box style={{ display: 'flex', flexDirection: 'column', width: '54%', padding: '16px 0px 16px 0px', gap: '16px' }}>
                                <Item sx={{ ...sx.itemsxGrow }}>
                                    <label htmlFor="cnAssignedCity" className="input-label" style={{fontSize:'small',fontWeight:700,width:'100px'}}>
                                        Assign Cities
                                    </label>
                                    <div tabIndex={0} id='cnAssignedCity' className='assignCity--field'
                                        onClick={() => {
                                            updateAssignCityModal()
                                        }}
                                        onKeyDown={(e) => {
                                            navigation3(e, 'cnAccBranch', 'cnEmailId', () => { updateAssignCityModal() })
                                        }}
                                    >
                                        {filters?.PartyCitiesNames === '' ? 'Assign Cities' : filters?.PartyCitiesNames}
                                    </div>
                                </Item>
                                <Box style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                                    <Item sx={{ ...sx.itemsxGrow, width: '49%' }}>
                                        <DropDownOA
                                            id='cnAccBranch'
                                            label={'Accounting Branch'}
                                            data={accBranchList || []}
                                            width="100%"
                                            defaultvalue={filters?.AccountingBranch}
                                            value={filters?.AccountingBranch}
                                            searchPlaceholder={`Search Accounting Branch Name`}
                                            dataKey={`BranchName`}
                                            idKey={`BranchID`}
                                            onSelect={(val) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    AccountingBranch: val.BranchName,
                                                    AccountingBranchID: val.BranchID
                                                }))
                                            }}
                                            onSelResetVal={true}
                                            nextId='cnCommission'
                                            prevId='cnAssignedCity'
                                        />
                                    </Item>
                                    <Item sx={{ ...sx.itemsxGrow, width: '23.4%' }}>
                                        <DropDownOA
                                            id='cnCommission'
                                            label={'Commission'}
                                            data={commissionList || []}
                                            width="100%"
                                            defaultvalue={filters?.Commission?.name}
                                            value={filters?.Commission?.name}
                                            searchPlaceholder={`Search Commission`}
                                            dataKey={`name`}
                                            idKey={`id`}
                                            onSelect={(val) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    Commission: val
                                                }))
                                            }}
                                            onSelResetVal={true}
                                            listWidth={'200px'}
                                            nextId='cnPercentage'
                                            prevId='cnAccBranch'
                                        />
                                    </Item>
                                    <Item className="input--wrapper" sx={{ ...sx.itemsxGrow, width: '23.4%' }}>
                                        {filters?.Commission?.id === 0 ? <Lineinput
                                            id='cnPercentage'
                                            label="Percentage"
                                            value={filters?.CommissionPCT}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    CommissionPCT: (e.target.value).replaceAll(/\D/g, ''),
                                                    CommissionAmt: 0
                                                }))
                                            }}
                                            onBlur={(e) => {
                                                // setFilters((prev) => ({
                                                //     ...prev,
                                                //     CommissionPCT: 0,
                                                //     CommissionAmt: 0
                                                // }))
                                                if (e.target.value > 100) {
                                                    updateAlertError({ show: true, msg: 'Percentage Value Cannot Be Greater Than 100', nextId: 'cnPercentage' })
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnTargetAmt', 'cnCommission')
                                            }}
                                        /> : <Lineinput
                                            id='cnPercentage'
                                            label="Amount"
                                            value={filters?.CommissionAmt}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    CommissionAmt: (e.target.value).replaceAll(/\D/g, ''),
                                                    CommissionPCT: 0
                                                }))
                                            }}
                                            onBlur={(e) => { }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnTargetAmt', 'cnCommission')
                                            }}
                                        />}
                                    </Item>
                                </Box>
                                <Box style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                                    <Item className="input--wrapper" sx={{ ...sx.itemsxGrow, width: '23.4%' }}>
                                        <Lineinput
                                            id='cnTargetAmt'
                                            label="Target Amount"
                                            value={filters?.TargetAmount}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    TargetAmount: (e.target.value).replaceAll(/\D/g, '')
                                                }))
                                            }}
                                            onBlur={(e) => { }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnDiscPer', 'cnPercentage')
                                            }}
                                        />

                                    </Item>
                                    <Item className="input--wrapper" sx={{ ...sx.itemsxGrow, width: '23.4%' }}>
                                        <Lineinput
                                            id='cnDiscPer'
                                            label="Discount  %"
                                            value={filters?.Discount}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    Discount: (e.target.value).replaceAll(/\D/g, '')
                                                }))
                                            }}
                                            onBlur={(e) => {
                                                if (e.target.value > 100) {
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        Discount: 0
                                                    }))
                                                    updateAlertError({ show: true, msg: 'Percentage Value Cannot Be Greater Than 100', nextId: 'cnPercentage' })
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnStartDate', 'cnTargetAmt')
                                            }}
                                        />
                                    </Item>
                                    <Item sx={{ ...sx.itemsxGrow, width: '23.4%' }} className="input--container bookingDatePicker">
                                        <Datepicker
                                            label='Start Date'
                                            id='cnStartDate'
                                            value={filters?.TargetStartDate === '' || filters?.TargetStartDate === null || filters?.TargetStartDate === undefined ? '' : moment(filters?.TargetStartDate)}
                                            dateChange={(date) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    TargetStartDate: date,
                                                    TargetEndDate:date
                                                }))
                                                focusElemnt('cnEndDate')
                                            }}
                                            width="100%"
                                            startDate={moment(new Date())} //will return previous 1 year date
                                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 365)} //will return future 1 year date
                                        />
                                    </Item>
                                    <Item sx={{ ...sx.itemsxGrow, width: '23.4%' }} className="input--container bookingDatePicker">
                                        <Datepicker
                                            label='End Date'
                                            id='cnEndDate'
                                            value={filters?.TargetEndDate === '' || filters?.TargetEndDate === null || filters?.TargetEndDate === undefined ? '' : moment(filters?.TargetEndDate)}
                                            dateChange={(date) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    TargetEndDate: date
                                                }))
                                                focusElemnt('cnAuthorizedBy')
                                            }}
                                            width="100%"
                                            startDate={filters?.TargetStartDate||moment(new Date())} 
                                            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 365)} //will return future 1 year date
                                        />
                                    </Item>
                                </Box>
                                <Box style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
                                    <Item sx={{ ...sx.itemsxGrow, width: '3%' }}>
                                        <Checkbox
                                            id={`cnIsBookingCreditParty`}
                                            checked={filters?.IsBookingCreditParty === 1}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    IsBookingCreditParty: e.target.checked ? 1 : 0,
                                                    BookingCreditLimitDD: isEdit ? e.target.checked ? (editData?.BookingCreditLimit === 0 ? ctreditLimitList?.[1] : ctreditLimitList?.[0]) : "" : '',
                                                    BookingCreditLimit: isEdit ? e.target.checked ? editData?.BookingCreditLimit : 0 : 0
                                                }))
                                                if (!e.target.checked) {
                                                    setResetBkgDD(true)
                                                    setTimeout(() => {
                                                        setResetBkgDD(false)
                                                    }, 10)
                                                }
                                            }}
                                            sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnBkngCredLimit', 'cnAuthorizedBy')
                                            }}
                                        />
                                    </Item>

                                    <Item sx={{ ...sx.itemsxGrow, width: '18.6%' }}>
                                        <DropDownOA
                                            id='cnBkngCredLimit'
                                            label={'Credit Limit'}
                                            data={ctreditLimitList || []}
                                            width="100%"
                                            defaultvalue={filters?.BookingCreditLimitDD?.name}
                                            value={filters?.BookingCreditLimitDD?.name}
                                            searchPlaceholder={`Search Limit`}
                                            dataKey={`name`}
                                            idKey={`id`}
                                            onSelect={(val) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    BookingCreditLimitDD: val,
                                                    BookingCreditLimit: val.id === 1 ? 0 : isEdit ? editData?.BookingCreditLimit : 0
                                                }))
                                            }}
                                            resetFlag={resetBkgDD}
                                            noCross={true}
                                            listWidth={'150px'}
                                            disabled={filters?.IsBookingCreditParty === 0}
                                            nextId='cnBkngAmt'
                                            prevId='cnPercentage'
                                        />
                                    </Item>
                                    <Item className="input--wrapper" sx={{ ...sx.itemsxGrow, width: '23.4%' }}>
                                        <Lineinput
                                            id='cnBkngAmt'
                                            label="Amount"
                                            value={filters?.BookingCreditLimit}
                                            disabled={filters?.BookingCreditLimitDD?.id === 1 || filters?.BookingCreditLimitDD === ''}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    BookingCreditLimit: (e.target.value).replaceAll(/\D/g, '')
                                                }))
                                            }}
                                            onBlur={(e) => { }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnIsRecvParty', 'cnBkngCredLimit')
                                            }}
                                        />
                                    </Item>
                                    <Item sx={{ ...sx.itemsxGrow, width: '3%' }}>
                                        {/* <Checkbox
                                            id={`cnIsDelCreditParty`}
                                            checked={filters?.IsDelCreditParty === 1}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    IsDelCreditParty: e.target.checked ? 1 : 0,
                                                    DeliveryCreditLimitDD: isEdit ? e.target.checked ? (editData?.DeliveryCreditLimit === 0 ? ctreditLimitList?.[1] : ctreditLimitList?.[0]) : "" : '',
                                                    DeliveryCreditLimit: isEdit ? e.target.checked ? editData?.DeliveryCreditLimit : 0 : 0
                                                }))
                                                setResetDelDD(true)
                                                setTimeout(() => {
                                                    setResetDelDD(false)
                                                }, 10)
                                            }}
                                            sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnDelCredLimit', 'cnBkngAmt')
                                            }}
                                        /> */}
                                    </Item>
                                    <Item sx={{ ...sx.itemsxGrow, width: '18.6%' }}>
                                        {/* <DropDownOA
                                            id='cnDelCredLimit'
                                            label={'Delivery Limit'}
                                            data={ctreditLimitList || []}
                                            width="100%"
                                            defaultvalue={filters?.DeliveryCreditLimitDD?.name}
                                            value={filters?.DeliveryCreditLimitDD?.name}
                                            searchPlaceholder={`Search Limit`}
                                            dataKey={`name`}
                                            idKey={`id`}
                                            onSelect={(val) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    DeliveryCreditLimitDD: val,
                                                    DeliveryCreditLimit: val.id === 1 ? 0 : isEdit ? editData?.DeliveryCreditLimit : 0
                                                }))
                                            }}
                                            resetFlag={resetDelDD}
                                            noCross={true}
                                            listWidth={'150px'}
                                            disabled={filters?.IsDelCreditParty === 0}
                                            nextId='cnDelAmt'
                                            prevId='cnIsDelCreditParty'
                                        /> */}
                                    </Item>
                                    <Item className="input--wrapper" sx={{ ...sx.itemsxGrow, width: '23.4%' }}>
                                        {/* <Lineinput
                                            id='cnDelAmt'
                                            label="Amount"
                                            value={filters?.DeliveryCreditLimit}
                                            disabled={filters?.DeliveryCreditLimitDD?.id === 1 || filters?.DeliveryCreditLimitDD === ''}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    DeliveryCreditLimit: (e.target.value).replaceAll(/\D/g, '')
                                                }))
                                            }}
                                            onBlur={(e) => { }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnIsRecvParty', 'cnDelCredLimit')
                                            }}
                                        /> */}
                                    </Item>
                                </Box>

                            </Box>
                        </Box>
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '12px' }}>
                            <Item sx={{ ...sx.itemsxGrow, width: '23%' }}>
                                <FormControlLabel
                                    value="end"
                                    sx={{ marginX: '0px', maxHeight: '36px' }}
                                    control={
                                        <Checkbox
                                            id={`cnIsRecvParty`}
                                            checked={Number(filters?.IsReceivingParty) === 1}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    IsReceivingParty: e.target.checked ? 1 : 0
                                                }))
                                            }}
                                            sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnIsRCMAppliied', 'cnDelAmt')
                                            }}
                                        />
                                    }
                                    label="Is Receiving Party"
                                    labelPlacement="end"
                                />
                            </Item>
                            <Item sx={{ ...sx.itemsxGrow, width: '23%' }}>
                                <FormControlLabel
                                    value="end"
                                    sx={{ marginX: '0px', maxHeight: '36px' }}
                                    control={
                                        <Checkbox
                                            id={`cnIsRCMAppliied`}
                                            checked={filters?.IsRCM === 1}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    IsRCM: e.target.checked ? 1 : 0
                                                }))
                                            }}
                                            sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnRateIncAllChrgs', 'cnIsRecvParty')
                                            }}
                                        />
                                    }
                                    label="Is RCM Applicable"
                                    labelPlacement="end"
                                /> </Item>
                            <Item sx={{ ...sx.itemsxGrow, width: '27%' }}>
                                <FormControlLabel
                                    value="end"
                                    sx={{ marginX: '0px', maxHeight: '36px' }}
                                    control={
                                        <Checkbox
                                            id={`cnRateIncAllChrgs`}
                                            checked={filters?.IsRateIncludeAll === 1}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    IsRateIncludeAll: e.target.checked ? 1 : 0
                                                }))
                                            }}
                                            sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnIsCorporateParty', 'cnIsRCMAppliied')
                                            }}
                                        />
                                    }
                                    label="Rate Incl. All Chgs"
                                    labelPlacement="end"
                                /></Item>
                            <Item sx={{ ...sx.itemsxGrow, width: '27%', justifyContent: 'space-between' }}>
                                <FormControlLabel
                                    value="end"
                                    sx={{ marginX: '0px', maxHeight: '36px' }}
                                    control={
                                        <Checkbox
                                            id={`cnIsCorporateParty`}
                                            checked={Number(filters?.IsCorporateParty) === 1}
                                            onChange={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    IsCorporateParty: e.target.checked ? 1 : 0
                                                }))
                                            }}
                                            sx={{ fontSize: '12px', backgroundColor: 'transparent !important', padding: '0px 0px', textAlign: 'center' }}
                                            onKeyDown={(e) => {
                                                navigation1(e, 'cnStatus', 'cnRateIncAllChrgs')
                                            }}
                                        />
                                    }
                                    label="Is Corporate Party"
                                    labelPlacement="end"
                                />
                                {filters?.IsCorporateParty === 1 && <span onClick={() => { updateConfirmationModal() }} style={{ fontSize: '11px', width: '40%', color: '#FE5200', paddingLeft: '10px', textDecoration: 'underline' }}> Corporate Rate Config (Click Here)</span>}
                            </Item>
                        </Box>
                    </Stack>
                    <Stack style={{ borderTop: '1px solid rgba(0, 0, 0, 0.2)', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '10px', padding: '12px 16px 5px 16px' }}>
                        <Item className={` beachTransBottomSec`} sx={{ paddingTop: '0px', background: '#F5FAFE', width: '14%' }}>
                            <DropDownOA
                                id={'cnStatus'}
                                label={'Party Status'}
                                width="100%"
                                data={statusList || []}
                                defaultvalue={filters?.IsActive === 1 ? 'Active' : 'InActive'}
                                // value={filters?.IsActive}
                                searchPlaceholder={`Search Status`}
                                dataKey={`name`}
                                idKey={`id`}
                                isError={filters?.IsActive == 0}
                                isSuccess={filters?.IsActive == 1}
                                // onSelResetVal={true}
                                noCross={true}
                                onSelect={(val) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        IsActive: val.id
                                    }))
                                }}
                                nextId='cnCancelBtn'
                                prevId='cnIsCorporateParty'
                            />
                        </Item>
                        <Button
                            id="cnCancelBtn"
                            style={{ margin: '0', height: "40px" }}
                            className="btn cancel-btn"
                            variant="outlined"
                            color="error"
                            onClick={() => {
                                handleCancel()
                            }}
                            onKeyDown={(e) => {
                                navigation3(e, 'abtSaveBtn', 'cnStatus', () => { });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            id="abtSaveBtn"
                            style={{ margin: '0px 0px 0px 5px', height: "40px" }}
                            className="btn add-btn"
                            variant="contained"
                            color="error"
                            onClick={() => handleSave()}
                            // onClick={() => { handleOtpVarify(); }}
                            onKeyDown={(e) => {
                                navigation3(e, 'cnPartyName', 'cnCancelBtn', () => { });
                            }}
                        >
                            {isEdit ? 'Update' : 'Save'}
                        </Button>
                    </Stack>
                </>
            </Modal>
            {showOtpModal && <PartySaveEditOtpModal dataValues={verifyOtpData} updateModal={setShowOtpModal} />}
            {/* {showMobileModal && <MobileNoVerificationModal dataValues={verifyMobileNoData} />} */}
            {showLocationModal && <MapLocation {...locationData} recentAddressList={getRecentSearches()} setAddress={setBranchAddress} address={BranchAddress} />}
            {showAssignCityModal && <AssignCitiesModal dataValues={assignCityData} />}
            {showConfirmModal && <ConfirmationModal dataValues={confirmData} />}
            <SuccessAndErrorModal handleClose={() => { handleSuccessModalClose() }} open={isSuccess} title={isEdit ? 'Selected Party Details\n Updated Successfully!' : 'New Party \n Saved Successfully!'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    updateModal, updateAlertError, validateGSTNumber, verifyPanNumber, getCityList, getBranchAndCityList,
    partyConfigInsertUpdate
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateNewPartyModal)
